export default __webpack_public_path__ + "static/media/phone-call.cbc2c44e.svg";